import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaPencil } from "react-icons/fa6";
import axios from "axios";

const Preferences = ({ userData, onUpdate, onFieldChange }) => {
  const [file, setFile] = useState(null);
  const [submissionMessage, setSubmissionMessage] = useState("");
  const [buttonClicked, setButtonClicked] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(
    userData.preferences?.technicianStamp
      ? `https://hms.backend.hiragroupcloud.com${userData.preferences.technicianStamp}`
      : ""
  );

  const languages = [
    "English (US)", "Spanish", "French", "German", "Chinese (Simplified)",
    "Arabic", "Hindi", "Russian", "Portuguese", "Japanese", "Bengali",
    "Urdu", "Indonesian", "Turkish", "Italian", "Thai", "Korean",
    "Vietnamese", "Tamil", "Filipino",
  ];

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    onFieldChange("preferences", name, type === "checkbox" ? checked : value);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    if (selectedFile) {
      const url = URL.createObjectURL(selectedFile);
      setPreviewUrl(url);
    } else {
      setPreviewUrl(
        userData.preferences?.technicianStamp
          ? `https://hms.backend.hiragroupcloud.com${userData.preferences.technicianStamp}`
          : ""
      );
    }
  };

  const handleSavePreferences = async () => {
    try {
      setButtonClicked(true);
      setSubmissionMessage("");

      const userId = localStorage.getItem("userId");
      if (!userId) {
        throw new Error("User ID not found in local storage");
      }

      let serverFilePath = userData.preferences?.technicianStamp || "";

      if (file) {
        const formData = new FormData();
        formData.append("technicianStamp", file);
        formData.append("userId", userId);

        const toastId = toast.loading("Uploading technician stamp...", {
          position: "top-center",
        });

        try {
          const response = await axios.post(
            `https://hms.backend.hiragroupcloud.com/api/auth/upload-stamp`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          if (response.data.success) {
            toast.update(toastId, {
              render: "Technician stamp uploaded successfully!",
              type: "success",
              isLoading: false,
              autoClose: 3000,
            });
            serverFilePath = response.data.filePath;
            setPreviewUrl(`https://hms.backend.hiragroupcloud.com${response.data.filePath}`);
            onFieldChange("preferences", "technicianStamp", response.data.filePath);
          }
        } catch (err) {
          toast.update(toastId, {
            render: err.response?.data?.message || "Failed to upload technician stamp",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
          setButtonClicked(false);
          return;
        }
      }

      const updatedData = {
        ...userData,
        preferences: {
          ...userData.preferences,
          teethNotation: userData.preferences?.teethNotation || "Universal",
          language: userData.preferences?.language || "English (US)",
          disableRxTyping: userData.preferences?.disableRxTyping || false,
          technicianStamp: serverFilePath,
        },
      };

      const success = await onUpdate(updatedData);
      if (success) {
        setSubmissionMessage("Preferences saved successfully!");
        toast.success("Preferences updated successfully!", {
          position: "top-center",
          autoClose: 3000,
        });
      }
    } catch (err) {
      console.error("Failed to save preferences:", err);
      toast.error(err.response?.data?.message || "Failed to save preferences", {
        position: "top-center",
        autoClose: 3000,
      });
    } finally {
      setTimeout(() => setButtonClicked(false), 3000);
    }
  };

  useEffect(() => {
    return () => {
      if (previewUrl && previewUrl.startsWith('blob:')) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  return (
    <div style={{ width: "95%", margin: "0 auto" }}>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="row">
        <div className="col-md-2" style={{ borderRight: "1px solid #004aad" }}></div>
        <div className="col-md-10">
          <h1>Preferences</h1>
          <div
            style={{
              border: "1px solid #f8f9fa",
              borderTop: "3px solid #004aad",
              backgroundColor: "#f8f9fa",
              padding: "20px",
            }}
          >
            <div>
              <h4>Teeth Notation</h4>
              <label style={{ marginLeft: "12%" }}>
                <input
                  type="radio"
                  name="teethNotation"
                  value="Universal"
                  checked={userData.preferences?.teethNotation === "Universal"}
                  onChange={handleInputChange}
                />{" "}
                Universal
              </label>
              <br />
              <label style={{ marginLeft: "12%" }}>
                <input
                  type="radio"
                  name="teethNotation"
                  value="FDI"
                  checked={userData.preferences?.teethNotation === "FDI"}
                  onChange={handleInputChange}
                />{" "}
                FDI
              </label>
            </div>

            <div style={{ marginTop: "20px" }}>
              <h4>Language</h4>
              <select
                name="language"
                value={userData.preferences?.language || "English (US)"}
                onChange={handleInputChange}
                style={{ marginLeft: "12%" }}
              >
                {languages.map((lang, index) => (
                  <option key={index} value={lang}>
                    {lang}
                  </option>
                ))}
              </select>
            </div>

            <div style={{ marginTop: "20px" }}>
              <p>
                Upload your technician stamp (PNG, JPEG, GIF)
                <br />
                Your stamp will be resized to 120px x 110px.
              </p>
              <h4>Technician's Stamp</h4>
              <input
                type="file"
                onChange={handleFileChange}
                style={{ marginLeft: "12%" }}
                accept="image/png,image/jpeg,image/gif"
              />
              {previewUrl && (
                <div style={{ marginTop: "10px", marginLeft: "12%" }}>
                  <img
                    src={previewUrl}
                    alt="Technician Stamp"
                    style={{
                      width: "120px",
                      height: "110px",
                      objectFit: "contain",
                      border: "1px solid #ccc",
                      marginTop: "10px",
                    }}
                  />
                </div>
              )}
              {(file || userData.preferences?.technicianStamp) && (
                <p style={{ marginLeft: "12%", marginTop: "10px" }}>
                  {file ? file.name : userData.preferences.technicianStamp.split('/').pop()}
                </p>
              )}
            </div>

            <div
              style={{
                marginLeft: "12%",
                marginTop: "20px",
                fontWeight: "bold",
              }}
            >
              <input
                type="checkbox"
                name="disableRxTyping"
                checked={userData.preferences?.disableRxTyping || false}
                onChange={handleInputChange}
              />{" "}
              Disable Rx Typing Suggestions
            </div>
          </div>

          <div style={{ marginTop: "20px", padding: "20px 30px" }}>
            <button
              onClick={handleSavePreferences}
              disabled={buttonClicked}
              style={{
                padding: "10px 20px",
                backgroundColor: "#004aad",
                color: "white",
                cursor: buttonClicked ? "not-allowed" : "pointer",
                border: "2px solid #004aad",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "600",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <FaPencil /> Save
            </button>
            {submissionMessage && (
              <div style={{ marginTop: "10px", color: "green" }}>
                {submissionMessage}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preferences;